import {
    SHOW_SETTINGS_PAGE,
    HIDE_SETTINGS_PAGE,
    TURN_OFF_CAMERA,
    TURN_OFF_MIC,
    TURN_ON_CAMERA,
    TURN_ON_MIC,
    TURN_OFF_HOST_CAMERA,
    TURN_ON_HOST_CAMERA,
    TURN_OFF_HOST_MIC,
    TURN_ON_HOST_MIC,
    SET_CAM_BEFORE_SCREEN_SHARE,
    SET_PASS_LOGIN,
    SHOW_ATTENDEE_COUNT,
    SET_OFF_RECORD,
    SET_START_RECORD,
    SET_UID,
    SET_COPRESENTER_INFO,
    SET_COPRESENTER_UIDS,
    SET_ROLE_COPRESENTER,
    SET_IS_SHOW_ATTENDEE_LIST,
    CHECK_RECORD,
    OFF_CHECK_RECORD,
    TURN_ON_SCREEN_SHARING,
    TURN_OFF_SCREEN_SHARING,
    TURN_ON_SCREEN_SHARING_TOAST,
    TURN_OFF_SCREEN_SHARING_TOAST,
    TOAST_MESSAGE,
    COPRESENTINFO,
    MUTECOPRESENTERUID,
    MUTEDBYHOST,
    CHANGEVIDEO,
    CHANGEAUDIO,
    USEPORTRAIT,
    SET_ROTATE_DEGREE,
    SET_PINNED_LAYOUT_UID,
} from './controls.actionTypes'

export function setRotateDegree(data: number): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_ROTATE_DEGREE,
            payload: data
        });
    }
}

export function setPortraitMode(data: boolean): any {
    return (dispatch: any) => {
        dispatch({
            type: USEPORTRAIT,
            payload: data
        });
    }
}

export function changeVideo(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: CHANGEVIDEO,
            payload: data
        });
    }
}

export function changeAudio(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: CHANGEAUDIO,
            payload: data
        });
    }
}

export function showSettingPage(): any {
    return (dispatch: any) => {
        dispatch({
            type: SHOW_SETTINGS_PAGE,
        });
    }
}

export function hideSettingPage(): any {
    return (dispatch: any) => {
        dispatch({
            type: HIDE_SETTINGS_PAGE,
        });
    }
}

export function setPassLogin(): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_PASS_LOGIN,
        });
    }

}

export function setRoleCoPresenter(data: boolean): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_ROLE_COPRESENTER,
            payload: data
        });
    }
}


export function turnOffCamera(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_OFF_CAMERA,
        });
    }
}

export function turnOnCamera(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_ON_CAMERA,
        });
    }
}

export function turnOnScreenSharing(): any {
    return {
        type: TURN_ON_SCREEN_SHARING,
    };
}

export function turnOffScreenSharing(): any {
    return {
        type: TURN_OFF_SCREEN_SHARING,
    };
}

export function turnOnScreenSharingToast(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_ON_SCREEN_SHARING_TOAST,
        });
    }
}

export function turnOffScreenSharingToast(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_OFF_SCREEN_SHARING_TOAST,
        });
    }
}

export function turnOffMic(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_OFF_MIC,
        });
    }
}

export function turnOnMic(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_ON_MIC,
        });
    }
}

export function turnOffHostCamera(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_OFF_HOST_CAMERA,
        });
    }
}

export function turnOnHostCamera(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_ON_HOST_CAMERA,
        });
    }
}

export function turnOffHostMic(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_OFF_HOST_MIC,
        });
    }
}

export function turnOnHostMic(): any {
    return (dispatch: any) => {
        dispatch({
            type: TURN_ON_HOST_MIC,
        });
    }
}

export function setCamBeforeScreenShare(data: boolean): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_CAM_BEFORE_SCREEN_SHARE,
            payload: data
        });
    }
}

export function showAttendeeCountFunc(data: boolean): any {
    return (dispatch: any) => {
        dispatch({
            type: SHOW_ATTENDEE_COUNT,
            payload: data
        });
    }
}

export function checkRecord(): any {
    return (dispatch: any) => {
        dispatch({
            type: CHECK_RECORD,
        });
    };
}

export function OffcheckRecord(): any {
    return (dispatch: any) => {
        dispatch({
            type: OFF_CHECK_RECORD,
        });
    };
}

export function turnOffRecord(): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_OFF_RECORD,
        });
    }
}

export function startRecord(): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_START_RECORD,
        });
    }
}

export function setUids(data: number): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_UID,
            payload: data
        });
    }
}

export function setCopresenterInfo(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_COPRESENTER_INFO,
            payload: data
        });
    }
}

export function setCopresenterUids(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_COPRESENTER_UIDS,
            payload: data
        });
    }
}
export function showIsAttendeeList(data: boolean): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_IS_SHOW_ATTENDEE_LIST,
            payload: data
        });
    }
}

export function toastMess(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: TOAST_MESSAGE,
            payload: data
        });
    }
}

export function copresenterInfo(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: COPRESENTINFO,
            payload: data
        });
    }
}

export function setCopresenterMuteUid(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: MUTECOPRESENTERUID,
            payload: data
        });
    }
}

export function setMutedByHost(data: any): any {
    return (dispatch: any) => {
        dispatch({
            type: MUTEDBYHOST,
            payload: data
        });
    }
}

export function setPinnedLayoutUid(data: number | null): any {
    return (dispatch: any) => {
        dispatch({
            type: SET_PINNED_LAYOUT_UID,
            payload: data
        });
    }
}
